module.exports = __webpack_public_path__ + "media/images/arrow-up-b07313e02cd5eb6665b5aaa2d8608d87.svg";